import styled from "styled-components";

export const Wrapper = styled.div``;
export const Container = styled.div`
  padding: 1em;
`;
export const Row = styled.div`
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5em;
  background: ${({ themed }) => (themed ? "#0F0E37" : "#ffffff")};
  padding: 0.5em 1em;
  border-radius: 15px;
  box-shadow: ${({ themed }) =>
    themed ? "0 0 15px #04031D" : "0 0 15px #eee"};
`;
export const Col = styled.div``;
export const Image = styled.div``;
export const Disp = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  p{
    font-weight: 700;
    line-height: 1.8
  }

  h5 {
    margin: 0;
    font-size: 1em;
  }
`;

export const Dot = styled.div`
  display: flex;
  flex-direction: column;
`;
